import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
  useMultiStyleConfig,
} from '@chakra-ui/react'
import { MultiStyleType } from '@chakra-ui/styled-system'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import { textStyleKeys } from '~/themes/textStyles'
import { textStyles } from '~/themes/textStyles/defaultTextStyles'
import { getName } from '~/utils/objectUtils'

const { PrimaryButton: PrimaryButtonColors } = themeColorSectionKeys.shared

const {
  FontColor: { Default: DefaultFontColor },
  Background: {
    SecondaryNav: { Hover: SecondaryNavHoverColor },
  },
} = themeColorSectionKeys.defaults

const transferTargetParts = ['container', 'label', 'name', 'button'] as const

const helpers = createMultiStyleConfigHelpers(transferTargetParts)

export const TransferTargetStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      height: '62px',
      width: 'full',
      paddingY: '12px',
      paddingX: '20px',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderRadius: '8px',
      backgroundColor: 'transparent',
      _hover: {
        backgroundColor: SecondaryNavHoverColor,
        '& div.refer-call-button': {
          display: 'flex',
        },
      },
    },
    label: {
      display: 'inline-flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    name: {
      display: 'inline-flex',
      maxHeight: '24px',
      alignSelf: 'center',
      paddingX: '12px',
      color: DefaultFontColor,
      ...textStyles[textStyleKeys.Body1],
    },
    button: {
      height: '38px',
      paddingY: '10px',
      paddingX: '18px',
      backgroundColor: PrimaryButtonColors.Background.Default,
      borderRadius: '100px',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      display: 'none',
      '& > p': {
        color: PrimaryButtonColors.FontColor.Default,
        textWrap: 'nowrap',
        ...textStyles[textStyleKeys.Body2_Semibold],
      },
    },
  },
  defaultProps: {},
})

export const useTransferTargetStyle = (props?: StyleThemingProps) => {
  return useMultiStyleConfig(
    getName({ TransferTargetStyle }),
    props,
  ) as MultiStyleType<typeof transferTargetParts>
}
